import React, { useState } from 'react'
import { FaCalculator } from 'react-icons/fa'
import '../Tools.css'

const VoltageDividerCalculator = () => {
    const [vin, setVin] = useState('12')
    const [r1, setR1] = useState('10000')
    const [r2, setR2] = useState('10000')
    const [mode, setMode] = useState('calculateVout')
    const [targetVout, setTargetVout] = useState('5')

    const calculateVout = () => {
        const vinVal = parseFloat(vin)
        const r1Val = parseFloat(r1)
        const r2Val = parseFloat(r2)

        if (isNaN(vinVal) || isNaN(r1Val) || isNaN(r2Val) || (r1Val + r2Val) === 0) {
            return null
        }

        return (vinVal * r2Val) / (r1Val + r2Val)
    }

    const calculateR2ForVout = () => {
        const vinVal = parseFloat(vin)
        const r1Val = parseFloat(r1)
        const voutVal = parseFloat(targetVout)

        if (isNaN(vinVal) || isNaN(r1Val) || isNaN(voutVal) || vinVal === 0 || vinVal === voutVal) {
            return null
        }

        return (voutVal * r1Val) / (vinVal - voutVal)
    }

    const vout = calculateVout()
    const calculatedR2 = calculateR2ForVout()

    const formatResistance = (value) => {
        if (value >= 1000000) {
            return `${(value / 1000000).toFixed(2)} M\u03A9`
        } else if (value >= 1000) {
            return `${(value / 1000).toFixed(2)} k\u03A9`
        }
        return `${value.toFixed(2)} \u03A9`
    }

    return (
        <div className="tool-calculator">
            <h3><FaCalculator /> Voltage Divider Calculator</h3>
            <p className="tool-description">Calculate the output voltage of a resistor voltage divider or find resistor values for a target voltage.</p>

            <div className="mode-selector">
                <button
                    className={`mode-btn ${mode === 'calculateVout' ? 'active' : ''}`}
                    onClick={() => setMode('calculateVout')}
                >
                    Calculate Vout
                </button>
                <button
                    className={`mode-btn ${mode === 'calculateR2' ? 'active' : ''}`}
                    onClick={() => setMode('calculateR2')}
                >
                    Find R2 for Target Vout
                </button>
            </div>

            <div className="voltage-divider-diagram">
                <div className="diagram-container">
                    <span className="diagram-label vin-label">Vin</span>
                    <div className="resistor-symbol r1-symbol">R1</div>
                    <span className="diagram-label vout-label">Vout</span>
                    <div className="resistor-symbol r2-symbol">R2</div>
                    <span className="diagram-label gnd-label">GND</span>
                </div>
            </div>

            <div className="divider-inputs">
                <div className="input-group">
                    <label>Input Voltage Vin (V)</label>
                    <input
                        type="number"
                        value={vin}
                        onChange={(e) => setVin(e.target.value)}
                        placeholder="12"
                    />
                </div>
                <div className="input-group">
                    <label>R1 (&Omega;)</label>
                    <input
                        type="number"
                        value={r1}
                        onChange={(e) => setR1(e.target.value)}
                        placeholder="10000"
                    />
                </div>
                {mode === 'calculateVout' ? (
                    <div className="input-group">
                        <label>R2 (&Omega;)</label>
                        <input
                            type="number"
                            value={r2}
                            onChange={(e) => setR2(e.target.value)}
                            placeholder="10000"
                        />
                    </div>
                ) : (
                    <div className="input-group">
                        <label>Target Vout (V)</label>
                        <input
                            type="number"
                            value={targetVout}
                            onChange={(e) => setTargetVout(e.target.value)}
                            placeholder="5"
                        />
                    </div>
                )}
            </div>

            {mode === 'calculateVout' && vout !== null && (
                <div className="result-box">
                    <div className="result-row">
                        <span className="result-label">Output Voltage (Vout):</span>
                        <span className="result-value">{vout.toFixed(4)} V</span>
                    </div>
                    <div className="result-row">
                        <span className="result-label">Divider Ratio:</span>
                        <span className="result-value">{(vout / parseFloat(vin) * 100).toFixed(2)}%</span>
                    </div>
                </div>
            )}

            {mode === 'calculateR2' && calculatedR2 !== null && calculatedR2 > 0 && (
                <div className="result-box">
                    <div className="result-row">
                        <span className="result-label">Required R2:</span>
                        <span className="result-value">{formatResistance(calculatedR2)}</span>
                    </div>
                </div>
            )}
        </div>
    )
}

export default VoltageDividerCalculator
